import PopupEdit from '@/components/Popup/PopupEdit'

let PopupRouter = [{
  path: '/popup/:id/edit',
  name: 'PopupEdit',
  component: PopupEdit,
  meta: {
    title: 'Popup',
    requiresAuth: true,
    authorizations: ['popup_edit', 'desktop_access']
  }
}]

export default PopupRouter



// WEBPACK FOOTER //
// ./src/components/Popup/router.js